import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useTranslations } from '@ms/yammer-i18n-react';
import NavigationStrings from '@ms/yammer-strings/dist/Navigation';
import { discoverGroupsExploreUrl, discoverGroupsUrl } from '@ms/yammer-web-support/dist/urls';
import { useCallback, useMemo } from 'react';

import { usePageUrlClick } from '../../../navigation/SubHeader/hooks/usePageUrlClick';
import { VivaEngageNavigationHeaderPivotItem } from '../types';

type UseCommunitiesPivotItem = () => VivaEngageNavigationHeaderPivotItem;
export const useCommunitiesPivotItem: UseCommunitiesPivotItem = () => {
  const t = useTranslations(NavigationStrings);
  const onPageUrlClick = usePageUrlClick();
  const reportAndRedirectToDiscoverGroupsPage = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.CommunitiesTabClicked,
    });
    onPageUrlClick(discoverGroupsExploreUrl);
  }, [onPageUrlClick]);

  return useMemo(
    () => ({
      key: discoverGroupsExploreUrl,
      supportedRoutes: ['/groups', discoverGroupsUrl],
      onClick: reportAndRedirectToDiscoverGroupsPage,
      text: t.appNavigationCommunities(),
    }),
    [reportAndRedirectToDiscoverGroupsPage, t]
  );
};
